// Hand a blob to the browser as a named download. ONE implementation.
//
// A LEAF MODULE, and that is the point. This used to live in
// `assetFileDownload.js`, which imports `assetManagerApi` — so every call site
// that only wanted "save these bytes under this name" would have dragged the
// whole asset-manager client in with it, and six of them reimplemented the four
// lines instead. Nothing here imports anything, so using it is free from any
// context; `assetFileDownload.js` re-exports it so its own callers are unchanged.
//
// THREE THINGS ARE LOAD-BEARING, and the copies got two of them wrong:
//
//   - THE REVOKE IS DEFERRED. Revoking the object URL in the same tick as the
//     click CANCELS the download in some browsers — the navigation has not
//     started reading the blob yet. Four of the six copies revoked synchronously
//     (`AppMenuBar`, `BlueprintEditor`, `StoryLibraryPanel`,
//     `blueprintAssetTransfer`), which is a download that silently does nothing,
//     intermittently, depending on the browser and the file size.
//   - THE ANCHOR IS IN THE DOCUMENT. A detached `<a>` does not reliably fire a
//     download in Firefox; three of the copies never appended it.
//   - THE ANCHOR IS REMOVED. Otherwise every export leaks a node into <body>.
//
// It deliberately does NOT revoke on a timer the caller can cancel, or track the
// URL: one second is long enough for the browser to have taken the bytes and
// short enough that a page doing many exports does not hold them all.

/**
 * @param {Blob} blob
 * @param {string} filename  what the browser saves it as
 */
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
